import openPhotoSwipe from '../util/open-photoswipe';

function ariaToggle(container) {
  const toggleButtons = container.querySelectorAll('[data-aria-toggle]');
  if (toggleButtons.length) {
    toggleButtons.forEach((element) => {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        const currentTarget = event.currentTarget;
        currentTarget.setAttribute('aria-expanded', currentTarget.getAttribute('aria-expanded') == 'false' ? 'true' : 'false');
        const toggleID = currentTarget.getAttribute('aria-controls');
        document.querySelector(`#${toggleID}`).classList.toggle('expanding');
        setTimeout(function () {
          document.querySelector(`#${toggleID}`).classList.toggle('expanded');
        }, 40);
      });
    });
  }
}

function videoPopups(container) {
  const videoPopups = container.querySelectorAll('[data-video-popup]');
  if (videoPopups.length) {
    videoPopups.forEach((element) => {
      element.addEventListener('click', function (e) {
        const videoPopupHtml = element.getAttribute('data-video-popup');
        if (videoPopupHtml.trim() !== '') {
          e.preventDefault();

          const items = [
            {
              html: videoPopupHtml,
            },
          ];

          openPhotoSwipe(items);
        }
      });
    });
  }
}

function lazyImageBackgrounds() {
  document.addEventListener('lazyloaded', function (e) {
    const lazyImage = e.target.parentNode;
    if (lazyImage.classList.contains('lazy-image')) {
      lazyImage.style.backgroundImage = 'none';
    }
  });
}

export {lazyImageBackgrounds, videoPopups, ariaToggle};
